<template>
  <div class="container-fluid">
    <b-overlay :show="showOverlay" rounded="sm">
      <b-card class="mt-2 col-12">
        <b-tabs>
          <b-tab
            v-for="tab in tabs"
            :key="tab.title"
            :title="tab.title"
            lazy
            @click.prevent="setActiveTabName(tab.mode)"
          >
            <b-col cols="12">
              <SearchFilter
                ref="searchFilter"
                :mode="tab.mode"
                @handleSubmit="searchFilterSubmit"
              />
            </b-col>
          </b-tab>
        </b-tabs>
      </b-card>

      <b-col v-for="tab in activeTab" :id="tab" :key="tab" cols="12">
        <commonTable
          ref="tableCommon"
          :mode="tab"
          @handleManage="onManageBtnClicked"
          @handleManageSearch="onManageSearchBtnClicked"
          @handleGroup="getManageGroup"
          @handleOverlay="setOverlay"
          :clueAction="clueAction"
        >
          <b-tabs
            v-if="tabs.find((value) => value.mode === tab).subTabs.length > 0"
          >
            <b-tab
              v-for="subTab in tabs.find((value) => value.mode === tab).subTabs"
              :key="subTab.title"
              :title="subTab.title"
              lazy
              @click.prevent="
                setActiveTabSubName(
                  tabs.find((value) => value.mode === tab),
                  subTab.mode
                )
              "
            >
            </b-tab>
          </b-tabs>
        </commonTable>
      </b-col>
    </b-overlay>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BTabs,
  BTab,
  BButton,
  BCard,
  BCardHeader,
  BCardBody,
  BOverlay,
} from "bootstrap-vue";
import commonTable from "../components/commonTable.vue";
import SearchFilter from "../components/SearchFilter.vue";

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    BCard,
    BCardHeader,
    BCardBody,
    BOverlay,
    commonTable,
    SearchFilter,
  },
  data() {
    return {
      tabs: [
        {
          title: "แจ้งเบาะแส",
          mode: "List",
          activeTab: ["waiting"],
          subTabs: [
            { title: "รอดำเนินการ", mode: "waiting" },
            { title: "ดำเนินการ", mode: "doing" },
          ],
        },
      ],
      activeTab: ["List"],
      clueAction: "Action",
      showOverlay: false,
    };
  },
  methods: {
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    setActiveTabName(name) {
      this.activeTab = [];
      this.activeTab.push(name);
    },
    setActiveTabSubName(tab, mode) {
      tab.activeTab = [];
      tab.activeTab.push(mode);
      this.$refs.searchFilter[0].onSearchBtnClicked();
    },
    getActiveTabSubName() {
      try {
        const _this = this;
        const activeTab = _this.tabs.find(
          (value) => value.mode === _this.activeTab[0]
        );
        if (activeTab.activeTab !== null && activeTab.activeTab !== undefined) {
          if (activeTab.activeTab.length > 0) {
            return activeTab.activeTab[0];
          }
        }

        return null;
      } catch (ex) {
        console.log("getActiveTabSubName ex", ex);
        return null;
      }
    },
    onManageBtnClicked(id) {
      const _this = this;
      const routeData = this.$router.resolve({
        name: "ClueActionManage",
        query: {
          id: id,
          clueAction: _this.clueAction,
        },
      });
      window.open(routeData.href, "_blank");
    },
    onManageSearchBtnClicked(id) {
      const _this = this;
      const routeData = this.$router.resolve({
        name: "ClueSearchManage",
        query: {
          id: id,
          clueAction: "Search",
        },
      });
      window.open(routeData.href, "_blank");
    },
    getManageGroup(id) {
      console.log("getManageGroup");
    },
    searchFilterSubmit(params) {
      params.mode = "officer";
      params.tab = this.getActiveTabSubName();
      this.$refs.tableCommon[0].onSearchSubmit(params);
    },
    onBtnAddClicked() {
      window.open(this.$router.resolve({ name: "RoleManage" }).href, "_blank");
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
